import { useCallback } from 'react';

import { PREFERRED_UNIT_SYSTEMS, PreferredUnitSystem } from '@frontend/api';
import {
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  HStack,
  Text,
  GearIcon,
  Segment,
  SegmentControl,
  Switch,
} from '@frontend/legacy-components';

import { ViewerPopoverButton } from 'modules/common/viewer/components';
import { useLegacyDxfViewerToggleContext } from 'modules/common/viewer/context/LegacyDxfViewerToggleContext';

import { useDisplayOptions } from '../hooks/useDisplayOptions';

export const DxfDisplayOptionsPopover = () => {
  const { isLegacyDxfViewer, setIsLegacyDxfViewer } =
    useLegacyDxfViewerToggleContext();
  const {
    dimensionalPrecision,
    preferredUnitSystem,
    handleUnitsChange,
    handlePrecisionChange,
  } = useDisplayOptions();

  const handleLegacyDxfViewerToggleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setIsLegacyDxfViewer(event.target.checked);
    },
    [setIsLegacyDxfViewer],
  );

  return (
    <ViewerPopoverButton
      title="Display Options"
      icon={<GearIcon boxSize={3} />}
    >
      <>
        <FormControl mb={1.5}>
          <FormLabel>Units</FormLabel>
          <SegmentControl
            name="dxf-viewer-display-units"
            size="sm"
            value={preferredUnitSystem}
            onChange={(value) =>
              handleUnitsChange(value as PreferredUnitSystem)
            }
            w="100%"
          >
            <Segment value={PREFERRED_UNIT_SYSTEMS.IMPERIAL}>Imperial</Segment>
            <Segment value={PREFERRED_UNIT_SYSTEMS.METRIC}>Metric</Segment>
          </SegmentControl>
        </FormControl>
        <FormControl mb={1.5}>
          <FormLabel>Dimensional precision</FormLabel>
          <HStack>
            <Text fontSize="sm">Decimal places</Text>
            <NumberInput
              name="dxf-viewer-dimensional-precision"
              clampValueOnBlur
              focusInputOnChange
              max={6}
              min={0}
              step={1}
              value={dimensionalPrecision}
              onChange={handlePrecisionChange}
              pattern="[0-9]*(.[0-9]+)?"
              size="sm"
              width="auto"
            >
              <NumberInputField width={6} />
            </NumberInput>
          </HStack>
        </FormControl>
        <FormControl mb={1.5}>
          <FormLabel>Legacy DXF Viewer</FormLabel>
          <HStack>
            <Text fontSize="sm">Legacy DXF Viewer</Text>
            <Switch
              name="dxf-viewer-legacy-viewer-toggle"
              size="sm"
              isChecked={isLegacyDxfViewer}
              onChange={handleLegacyDxfViewerToggleChange}
            />
          </HStack>
        </FormControl>
      </>
    </ViewerPopoverButton>
  );
};
DxfDisplayOptionsPopover.displayName = 'DxfDisplayOptionsPopover';
